import React, { Component } from "react";
import { Parallax } from "react-parallax";

import ReactGA from "react-ga4";

import Header from "../Components/Header";
import Modal from "../Components/Modal";
import Content from "../Containers/Content";
import BuyTicket from "../Containers/BuyTicket";
import HeroImage from "../Containers/HeroImage";
import Footer from "../Containers/Footer";

import {
  rules_et,
  rules_ru,
  rules_et_vikinglotto,
  rules_ru_vikinglotto,
} from "../Rules/rules";
import { prize } from "../Rules/prize";
import Menu from "../Components/Menu";
import CookieModal from "../Containers/CookieModal";

export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalType: "rules",
      language: "et",
      activeTab: "lisaloos",
      activeRulesTab: "lisaloos",
      campaignHasEnded: false,
      campaignEndDate: 1661374800, 
    };
  }

  componentDidMount() {
    if (this.props.match.params.lang === "et") {
      this.changeLanguage("et", false);
    } else if (this.props.match.params.lang === "ru") {
      this.changeLanguage("ru", false);
    }
   this.getJson();
  }

 
  
  async getJson() {
    // const response = await fetch("json/winners-example.json");
    const response = await fetch("json/winners.json?t="+Date.now());
    const output = await response.json();
    // waits until the request completes...
    this.setState({
      campaignHasEnded: output.hasCampaignEnded,
      winners: output.winners,
    });
  }
  modalContent = () => {
    const { language, activeRulesTab } = this.state;
    if (this.state.modalType === "rules") {
      if (activeRulesTab === "lisaloos") {
        return language === "et" ? rules_et : rules_ru;
      } else {
        return language === "et" ? rules_et_vikinglotto : rules_ru_vikinglotto;
      }
    } else if (this.state.modalType === "prize") {
      return prize;
    } else {
      return "";
    }
  };

  goTo(ref) {
    document
      .getElementById(ref)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  showModal = (type = "rules") => {
    this.setState({
      showModal: true,
      modalType: type,
    });
  };

  changeLanguage = (lang, ga = true) => {
    if (!lang) {
      return lang;
    } else {
      this.setState({
        language: lang,
      });
      if (ga) {
        ReactGA.event({
          category: "aastaloos_2023",
          action: "click",
          label: "change language " + lang,
        });
      }
      return lang;
    }
  };
  toggleActiveTab = (tab, tabclick = false) => {
    const { activeTab } = this.state;
    if (tabclick) {
      if (activeTab === "miljoniloos") {
        tab = "lisaloos";
      } else {
        tab = "miljoniloos";
      }
    }
    this.setState({
      activeTab: tab,
    });
  };

  changeActiveRulesTab = (tab) => {
    this.setState({
      activeRulesTab: tab,
    });
  };

  render() {
    const { language, campaignHasEnded } = this.state;
    return (
      <>
        <Menu
          toggleActiveTab={this.toggleActiveTab}
          activeTab={this.state.activeTab}
          language={language}
          changeLanguage={this.changeLanguage}
          modal={this.showModal}
          goTo={this.goTo}
        />
        {!campaignHasEnded ? <BuyTicket language={language} /> : ""}
        <Parallax
          strength={300}
          renderLayer={(percentage) => {
            return (
              <>
                <Header percentage={percentage} language={language} />

                <HeroImage language={language} />
              </>
            );
          }}
        >
          <Content
            toggleActiveTab={this.toggleActiveTab}
            activeTab={this.state.activeTab}
            modal={this.showModal}
            language={language}
            campEnded={this.state.campaignHasEnded}
          />
        </Parallax>
        {this.state.showModal ? (
          <Modal close={(e) => this.closeModal()}>
            {this.state.modalType === "rules" ? (
              <>
              { <p><i>
                  {language === "et"
                    ? "Vikinglotto Miljoniloos on kirjeldatud Vikinglotto reeglites punktis 4."
                    : "Розыгрыш Миллиона приведён в пункте 4 правил Vikinglotto"}
               </i> </p>
               }
               
               <div className={`modal--tabs modal--tabs_${language}`}>
                  {" "}
                  <button
                    className={`${
                      this.state.activeRulesTab === "lisaloos"
                        ? "is-active"
                        : ""
                    }`}
                    onClick={() => this.changeActiveRulesTab("lisaloos")}
                  >
                    {language === "et"
                      ? "Lisaloosi reeglid"
                      : "Правила дополнительного розыгрыша"}
                  </button>
                  <button
                    className={`${
                      this.state.activeRulesTab !== "lisaloos"
                        ? "is-active"
                        : ""
                    }`}
                    onClick={() => this.changeActiveRulesTab("aastaloos")}
                  >
                    {language === "et"
                      ? `Vikinglotto reeglid`
                      : "Правила лотереи Vikinglotto"}
                  </button>
                </div>
              </>
            ) : (
              <></>
            )}
            {this.modalContent()}
          </Modal>
        ) : (
          ""
        )}
        <Footer language={language} />

        <CookieModal language={language} />
      </>
    );
  }
}
